@if ({
  mp4Progress: mp4FileConverted$ | async,
  pptProgress: presentationFileConverted$ | async,
  mp4PortraitToLandscapeProgress: mp4PortraitToLandscapeConverted$ | async
}; as convertion) {

  @if (showDetails && convertingMessage) {
    <span>{{ convertingMessage }}</span>
  }
  @else if (showDetails && convertion.pptProgress?.totalAmount) {
    <span>{{ transformedItemsAmount }} out of {{ convertion.pptProgress.totalAmount }}...</span>
  }
  @else if (showSimplifiedDetails) {
    <span class="title px-3">Converting <b>{{ item.PlaylistItemLinks[0]?.File?.FileName }}...</b></span>
  }

  <mat-progress-bar
    [ngClass]="{'mb-0': isRecentFilesTab}"
    [value]="percentage"
    [mode]="!(convertion.pptProgress?.totalAmount || convertingMessage) ? 'indeterminate' : 'determinate'">
  </mat-progress-bar>
}
